<template>
  <span class="send-offer-button__wrapper quoteActionsButtonWrapper">
    <app-button
      v-if="visible"
      data-qa="send-offer-button"
      :disabled="disabled"
      class="quoteActionsButton"
      @click="
        checkSaveQuoteChecks(SaveQuoteCheckType.checkCustomerType) && toggleSendOfferModal(true)
      "
    >
      {{ i18n.t('/QuoteActions/SendOfferButton') }}
    </app-button>

    <modal
      v-if="showSendOfferModal"
      :title="i18n.t('/QuoteActions/Forms/SendOfferTitle')"
      @close="toggleSendOfferModal(false)"
    >
      <send-offer-form @close="toggleSendOfferModal(false)" />
    </modal>
    <customer-type-prompt
      :show="showCustomerTypePrompt"
      @confirm="
        checkSaveQuoteChecks(SaveQuoteCheckType.checkExpireDate) && toggleSendOfferModal(true)
      "
      @close="showCustomerTypePrompt = false"
    />
    <expire-date-prompt
      :show="showExpireDatePrompt"
      @confirm="
        checkSaveQuoteChecks(SaveQuoteCheckType.checkExpectedDeliveryDate) &&
        toggleSendOfferModal(true)
      "
      @close="showExpireDatePrompt = false"
    />
    <expected-delivery-date-prompt
      :show="showExpectedDeliveryDatePrompt"
      @confirm="toggleSendOfferModal(true)"
      @close="showExpectedDeliveryDatePrompt = false"
    />
  </span>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import EmailBodyHelper from '@/helpers/EmailBodyHelper'
import SendOfferForm from '@/components/generic/presentational/organisms/quoteActions/SendOfferForm.vue'
import { mapState } from 'vuex'
import SaveQuoteCheckType from '@/helpers/enums/saveQuoteCheckType'
import CustomerTypePrompt from '@/components/generic/presentational/molecules/customerTypePrompt/CustomerTypePrompt.vue'
import CheckSaveQuote from '@/mixins/checkSaveQuote.js'
import ExpireDatePrompt from '@/components/generic/presentational/molecules/expireDatePrompt/ExpireDatePrompt.vue'
import ExpectedDeliveryDatePrompt from '@/components/generic/presentational/molecules/expectedDeliveryDatePrompt/ExpectedDeliveryDatePrompt.vue'
import AdditionalOrder from '@/mixins/additionalOrder.js'

export default {
  components: {
    Modal,
    AppButton,
    SendOfferForm,
    CustomerTypePrompt,
    ExpireDatePrompt,
    ExpectedDeliveryDatePrompt,
  },
  mixins: [AdditionalOrder, CheckSaveQuote],
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showSendOfferModal: false,
      emailBody: '',
      isMailCustomerChecked: false,
      isMailStaffChecked: false,
      loading: false,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      SaveQuoteCheckType,
    }
  },
  computed: {
    // Dynamic namespaces aren't supported by mapGetters
    ...mapState({
      quote(state, getters) {
        return getters[this.quoteNamespace + '/get']
      },
      hasCustomer(state, getters) {
        return getters[this.quoteNamespace + '/hasCustomer']
      },
      customer(state, getters) {
        return getters[this.quoteNamespace + '/customer']
      },
    }),
    customerHasEmailAddress() {
      return this.hasCustomer && this.customer.CustomerEmail
    },
  },
  methods: {
    openModal() {
      if (this.quote.QuoteDetails.EmailBodyQuote == null)
        this.emailBody = EmailBodyHelper.getRequestQuoteEmailBody(this.quote.QuoteDetails?.Customer)
      else this.emailBody = this.quote.QuoteDetails.EmailBodyQuote

      this.showModal = true
    },
    toggleSendOfferModal(show) {
      this.showSendOfferModal = show
    },
  },
}
</script>

<style lang="scss" scoped>
.send-offer-button__wrapper {
  display: inline-block;
}

.send-offer-button__email-message {
  height: 300px;
}

.send-offer-button__info-message {
  padding: 1.2em;
}

.send-offer-button__send-button {
  text-align: center;
}
</style>
